import { useRef } from 'react';

import { DOMAIN_DEFAULT } from '@blocks/constants';
import { useSessionStore } from '@blocks/stores/session';
import { ModalRef } from '@blocks/ui/modal';

const useAuthModal = (domain: string = DOMAIN_DEFAULT) => {
  const { customer } = useSessionStore(domain);
  const loginModal = useRef<ModalRef>(null);

  const openAuthModal = (state: { login: string }) => {
    if (loginModal && loginModal.current && !customer?.email && customer.email !== state.login) {
      loginModal.current.open();
      return null;
    }
    return state;
  };
  return { openAuthModal, loginModal };
};

export default useAuthModal;
